import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, SimpleChanges, OnChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'mat-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class StarRatingComponent implements OnInit, OnChanges {

  @Input('rating') public rating: number = 3;
  @Input('starCount') public starCount: number = 5;
  @Input('color') public color: string = 'accent';
  @Input('disabled') public disabled: number = 0;
  @Output() private ratingUpdated = new EventEmitter();
  @Input() form_group: UntypedFormGroup;
  @Input() form_control;
  @Input() data;

  private snackBarDuration: number = 2000;
  public ratingArr = [];

  constructor(private snackBar: MatSnackBar) {
  }


  ngOnInit() {
    //
    for (let index = 0; index < this.starCount; index++) {
      this.ratingArr.push(index);
    }
  }
  ngOnChanges(ev): void {

    if (ev && ev.disabled) {
      this.disabled = ev.disabled.currentValue
    }

    if (ev && ev.data) {
      this.data = ev.data.currentValue;
      // if (typeof this.data == "number") {
      //   if (this.data > 0) {
      //     for (let index = 0; index < this.data; index++) {
      //       this.ratingArr.push(index);
      //     }
      //   }
      //   else {
      //     this.ratingArr.push(0);
      //   }

      // }
      // else if (this.data > 0 && typeof this.data == "string") {
      //   this.data = parseInt(this.data);
      //   if (this.data > 0) {
      //     for (let index = 0; index < this.data; index++) {
      //       this.ratingArr.push(index);
      //     }
      //   }
      //   else {
      //     this.ratingArr.push(0);
      //   }
      // }

      if (this.form_group && this.form_group.controls[this.form_control]) {
        this.form_group.controls[this.form_control].patchValue(this.data);
      }

    }
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.

  }
  onClick(rating: number) {
    //
    // this.snackBar.open('You rated ' + rating + ' / ' + this.starCount, '', {
    //   duration: this.snackBarDuration
    // });
    if (this.form_group && this.form_group.controls[this.form_control]) {
      this.form_group.controls[this.form_control].patchValue(rating);
    }
    this.ratingUpdated.emit(rating);
    return false;
  }

  showIcon(index: number) {
    if (this.rating >= index + 1) {
      return 'star';
    } else {
      return 'star_border';
    }
  }

}
export enum StarRatingColor {
  primary = "primary",
  accent = "accent",
  warn = "warn"
}
